import { gql } from "@apollo/client";
export default gql`
  mutation UpdateUserDeviceSettings($input: UsersDeviceConfigInput!) {
    updateUserDeviceSettings(input: $input) {
      message
    }
  }
`;
